import { type VendorInvite } from '@webapp/modules/vendor/data-access/types/VendorInvite'

/**
 * The most recently created of a vendor's invite rows (re-invites after an
 * expiry or a manual cancellation each add one). `createdAt` is the one
 * timestamp every row carries; equal timestamps keep the order the API
 * returned. Which row the Vendor Details pane reads is decided by
 * getVendorPortalConnection, which prefers a connected row over this one.
 */
export const selectLatestVendorInvite = (
  invites: VendorInvite[]
): Nullable<VendorInvite> =>
  invites.reduce<Nullable<VendorInvite>>(
    (latest, invite) =>
      latest &&
      new Date(latest.createdAt).getTime() >=
        new Date(invite.createdAt).getTime()
        ? latest
        : invite,
    null
  )
